import { useQuery } from "@tanstack/react-query";
import { getCustomerLogQueries } from "../../service/query/auth";

export const useGetCustomerLogQueries = ({ membership_id, ticket_number, query_status, page, enabled }) => {
  return useQuery({
    queryKey: ["customerLogQueries", membership_id, ticket_number, query_status, page],
    queryFn: () => getCustomerLogQueries({ membership_id, ticket_number, query_status, page }),
    enabled: !!enabled,
  });
};